'use client';
import { CiFlag1 } from 'react-icons/ci';
import { RiHeartAdd2Line } from 'react-icons/ri';
import { TbHeartX } from 'react-icons/tb';

import { Button } from '@/slw/shared/ui/button';
import { cn } from '@/slw/shared/lib/utils';

interface ListingHeaderActionsProps {
  isFavorite: boolean;
  onFavorite?: () => void;
  onReport?: () => void;
  isLoading?: boolean;
}

export function ListingHeaderActions({ isFavorite, onFavorite, onReport, isLoading }: ListingHeaderActionsProps) {
  return (
    <div className='flex items-center gap-8'>
      <button
        type='button'
        disabled={isLoading}
        aria-label='Report listing'
        onClick={onReport}
        className={cn('cursor-pointer', isLoading && 'opacity-50 pointer-events-none')}
      >
        <CiFlag1 className={'w-4 h-4 text-destructive'} />
      </button>
      <Button
        type='button'
        aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
        variant={'default'}
        color='primary'
        className='gap-12'
        onClick={onFavorite}
        disabled={isLoading}
      >
        {isFavorite ? (
          <>
            <span className='text-nowrap'>DELETE FROM FAVORITE</span> <TbHeartX size={20} />
          </>
        ) : (
          <>
            <span className='text-nowrap'>ADD TO FAVORITE</span> <RiHeartAdd2Line size={20} />
          </>
        )}
      </Button>
    </div>
  );
}
